import { useQuery } from "@tanstack/react-query";
import { VERSIONS_KEY } from "../constants";
import { httpClient } from "../../config";
import { API_VERSIONS } from "../../common/consts/apiUrls";

export interface VersionsResponse {
  message: string;
  data: {
    versions: Versions;
  };
}

export interface Versions {
  backend: string;
  frontend: string;
  ai: string;
}

const fetchVersions = async (): Promise<VersionsResponse> => {
  return (await httpClient.get(API_VERSIONS)) as VersionsResponse;
};

export default function useVersionsQuery() {
  return useQuery({
    queryKey: [VERSIONS_KEY],
    queryFn: fetchVersions,
  });
}
